module.exports = __webpack_public_path__ + "static/media/secao-4-bg.0556c55c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/secao-4-bg.jpg
// module id = 910
// module chunks = 5